// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1dc6G","empty":"ModalGraph_empty__2bat-"};